<template>
  <div>
    <MainPageHeader v-if="!isAndroidContext"/>
    <div class="request-presentation" :class="{ androidVersion: isAndroidContext }">
      <ul class="errors" v-if="errors.length > 0">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
      <h2>Umów się na prezentację systemu</h2>
      <form action="" @submit.stop.prevent="joinPresentation">
        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="user" />
            <input type="text" required v-model="form.name" placeholder=" ">
            <span>Imię</span>
          </div>
        </label>

        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="phone-alt" />
            <input type="text" required v-model.lazy="form.phone" @input="validatePhone" placeholder=" ">
            <span>Numer telefonu</span>
          </div>
        </label>

        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="envelope" />
            <input type="text" required v-model="form.email" placeholder=" ">
            <span>Email</span>
          </div>
        </label>

        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="map-marked-alt" />
            <input type="text" required v-model="form.voivodeship" list="voivodeships" placeholder=" ">
            <span>Województwo</span>
          </div>
        </label>
        <datalist id="voivodeships">
          <option v-for="voivodeship in voivodeship_list" :key="voivodeship" :value="voivodeship" />
        </datalist>

        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="location-arrow" />
            <input type="text" v-model="form.place" placeholder=" ">
            <span>Miejsce prezentacji (opcjonalnie)</span>
          </div>
        </label>

        <label>
          <div class="input-group">
            <font-awesome-icon class="icon" icon="calendar" />
            <input type="date" v-model="form.date" placeholder=" ">
            <span>Data prezentacji (opcjonalnie)</span>
          </div>
        </label>

        <label>
          <div class="terms-checkbox">
            <input type="checkbox" v-model="termsAccepted" required>
            <span>Wyrażam zgodę na przetwarzanie moich danych podanych w formularzu w celu
              przeprowadzenia prezentacji systemu. Mam świadomość, że mam prawo do wycofania
              zgody w każdej chwili, co pozostanie bez wpływu na zgodność z prawem przetwarzania,
              które miało miejsce dotychczas. Więcej informacji o przetwarzaniu danych znajduje się
              w naszej
              <router-link
                  class="link"
                  :to="{ name: 'PDFView', params: { fileName: 'cookies.pdf' } }">Polityce prywatności.</router-link>
            </span>
          </div>
        </label>

        <LoadingButton
          type="submit"
          :isLoading="isLoading"
          class="request-button"
          >Umów prezentację systemu
        </LoadingButton>
      </form>
    </div>
    <Footer v-if="!isAndroidContext" :showOnlyCookies="true"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import { getPresentationService } from '@/services/presentationService'
import LoadingButton from "../components/input/LoadingButton.vue";
import Footer from '../components/Footer.vue';
import {getAndroidContext} from '@/services/sessionProps'
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope, faLocationArrow, faCalendar, faMapMarkedAlt, faPhoneAlt, faUser
} from '@fortawesome/free-solid-svg-icons'

library.add(faEnvelope, faLocationArrow, faCalendar, faMapMarkedAlt, faPhoneAlt, faUser)

export default {
  name: 'RequestPresentation',
  components: {
    MainPageHeader,
    LoadingButton,
    Footer
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        voivodeship: '',
        place: '',
        date: ''
      },
      termsAccepted: false,
      isLoading: false,
      errors: [],
      voivodeship_list: [
        "dolnośląskie",
        "kujawsko-pomorskie",
        "lubelskie",
        "lubuskie",
        "łódzkie",
        "małopolskie",
        "mazowieckie",
        "opolskie",
        "podkarpackie",
        "podlaskie",
        "pomorskie",
        "śląskie",
        "świętokrzyskie",
        "warmińsko-mazurskie",
        "wielkopolskie",
        "zachodniopomorskie"
      ]
    }
  },
    computed: {
    isAndroidContext() {
      return getAndroidContext().isAndroidContext()
    }
  },
  methods: {
    async joinPresentation() {
      this.errors = []

      if(!this.voivodeship_list.includes(this.form.voivodeship)) {
        this.errors.push("Wybierz województwo z listy")
      }

      if(/.*[a-zA-Z].*/.test(this.form.phone)) {
        this.errors.push("Wpisz poprawny numer")
      }

      if(this.errors.length === 0) {
        this.isLoading = true
        const payload = {
          name: this.form.name,
          phoneNumber: this.form.phone,
          email: this.form.email,
          voivodeship: this.form.voivodeship,
          presentationLocation: this.form.place,
          presentationDate: this.form.date || null
        }
        console.log(payload.presentation_location)
        await getPresentationService().joinPresentation(payload)
        this.$router.push({ name: 'mainPage' })
      }
    },
    validatePhone(e) {
      console.log(e)
      e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
      e.target.value = e.target.value.substr(0, 11)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.link {
  color: $gold;
}

.request-presentation {
  margin: auto;
  margin-top: calc(89.39px + 8rem);
  margin-bottom: 8rem;
  background: linear-gradient(to bottom left, #111, #222);
  display: block;
  max-width: 480px;
  padding: 3rem;
  border-radius: 3px;

  @media only screen and (max-width: $phone-max-width) {
    margin-top: 80.83px;
  }

  &.androidVersion {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0;
    margin-bottom: 0;
    height: 100vh;
  }
  .errors {
    background: #f9969669;
    border: solid 1px #ff5d5d;
    padding: 1rem;
    list-style-type: none;
  }
  h2 {
    text-align: center;
    text-transform: uppercase;
    color: $gold;
    margin-top: 0;
  }
  form {
    label {
      margin: auto;
      display: block;
      display: flex;
      flex-direction: column-reverse;
      .input-group {
        border-bottom: solid 1px $gold;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        position: relative;
        padding-top: .7rem;
        span {
          display: block;
          text-transform: uppercase;
          font-size: 12px;
          left: 42px;
          top: calc(.35rem + 50%);
          transform: translateY(-50%);
          user-select: none;
          pointer-events: none;
          transition: top .3s, left .3s;
          position: absolute;
        }
        .icon {
          color: $gold;
          font-size: 22px;
          margin: 0 .5rem;
        }
        input {
          width: 100%;
          background: transparent;
          border: none;
          padding: .5rem;
          color: #fff;
          font-size: 18px;
          &:focus, &:not(:placeholder-shown) {
            outline: none;
            & + span {
              top: 0;
              left: 0;
            }
          }
          &[type=date] {
            position: relative;
            &::-webkit-calendar-picker-indicator {
              background: transparent;
              color: transparent;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              position: absolute;
              height: auto;
              width: auto;
              cursor: pointer;
            }
          }
        }
      }
      .terms-checkbox {
        color: gray;
        font-size: 12px;
      }
    }
    .request-button {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }
  }
}
</style>